export default __webpack_public_path__ + "static/media/nt-10.f6b62725.jpg";